module.exports = __webpack_public_path__ + "static/media/SF-Pro-Display-Medium.51fd7406.otf";